
<script>
import { Form } from 'element-ui'

const renderFun = {
  text: 'renderInput',
  textarea: 'renderInput',
  number: 'renderNumber',
  select: 'renderSelect',
  datetime: 'renderDatetime',
  component: 'renderComponent'
}

export default {
  name: 'SearchForm',
  extends: Form,
  props: {
    col: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    loading: Boolean,
    actionBlock: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    renderInput(configObj) {
      const { type, key, componentProps, on = {} } = configObj
      const ph = componentProps.placeholder ?? '请输入'

      return (
        <el-input
          type={type}
          vModel={this.model[key]}
          vOn:keyup_native={this.handleEnter}
          { ...{ props: componentProps, attrs: { placeholder: ph }, on: on } }
        >
        </el-input>)
    },
    renderNumber(configObj) {
      const { key, componentProps, on = {} } = configObj

      return (
        <el-input-number vModel={this.model[key]} vOn:keyup_native={this.handleEnter} { ...{ props: componentProps, on: on } }>
        </el-input-number>)
    },
    renderSelect(configObj) {
      const { key, componentProps, on = {}, options } = configObj
      return (<el-select vModel={this.model[key]} { ...{ props: componentProps, on: on } }>
        { Object.entries(options).map(([key, value]) => {
          return (<el-option key={+key} label={value} value={+key}></el-option>)
        }) }
      </el-select>)
    },
    renderDatetime(configObj) {
      const { key, componentProps, on = {} } = configObj
      return (<el-date-picker vModel={this.model[key]} { ...{ props: componentProps, on: on } }></el-date-picker>)
    },
    renderComponent(configObj) {
      const { key, componentProps, on = {}, component } = configObj
      const ph = componentProps.placeholder ?? '请输入'

      return (<component vModel={this.model[key]} { ...{ props: componentProps, attrs: { placeholder: ph }, on: { submit: this.submit, ...on } } }></component>)
    },
    renderField(configObj) {
      if (renderFun[configObj.type]) {
        return this[renderFun[configObj.type]](configObj)
      }
      return null
    },
    handleEnter(e) {
      if (e.keyCode === 13) {
        this.submit()
      }
    },
    submit() {
      this.$refs.searchFormRef.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.model)
        }
      })
    },
    reset() {
      this.$refs.searchFormRef.resetFields()
      this.$emit('reset')
    }
  },

  render(h, context) {
    const { $slots, $props } = this
    const { col, items, loading, ...formProps } = $props

    return (
      <el-form
        ref="searchFormRef"
        class={['el-form search-form', col ? `items-${col}` : '']}
        { ...{ props: formProps } }
      >
        {
          items.map(config => {
            return (<el-form-item label={config.label} rules={config.rules} prop={config.key}>
              { this.renderField(config) }
            </el-form-item>)
          })
        }
        {
          $slots.btns
            ? $slots.btns
            : <el-form-item class={{ btns: true, block: this.actionBlock }}>
              <el-button onClick={this.reset}>重 置</el-button>
              <el-button type="primary" loading={loading} onClick={this.submit}>查 询</el-button>
            </el-form-item>
        }
        { $slots.default }
      </el-form>
    )
  }
}
</script>

<style lang="scss">
.search-form {

  &[class*="items-"] {
    display: flex;
    flex-wrap: wrap;
    >.el-form-item {
      display: flex;

      >.el-form-item__content {
        flex-grow: 1;
        >div[class*="el-"] {
          width: 100%;
        }
      }
    }
  }
  &.items-5 {
    >.el-form-item {
      min-width: 20%;
      width: 20%;
    }
  }
  &.items-4 {
    >.el-form-item {
      min-width: 25%;
      width: 25%;
    }
  }
  &.items-3 {
    >.el-form-item {
      min-width: 33%;
      width: 33%;
    }
  }
  &.items-2 {
    >.el-form-item {
      min-width: 50%;
      width: 50%;
    }
  }
  .el-form-item {
    margin-right: 0;
    margin-bottom: 8px !important;
    padding-right: 8px;

    &.btns.block  {
      min-width: 100%;
      width: 100%;

      .el-form-item__content {
        display: flex;
        justify-content: flex-end;
        padding-right: 8px;
      }
    }
  }
}
</style>
